export const de = {
  clear: 'sauber',
  choose: 'Wählen',
  no_options: 'Keine Optionen',
  additional_operator_description: 'Zusätzliche Beschreibung des Betreibers:',
  departure: 'Abfahrt',
  arrival: 'Ankunft',
  departure_date: 'Abreisedatum',
  departure_date_capital: 'Abreisedatum',
  arrival_date: 'Datum der Ankunft',
  arrival_date_capital: 'Datum der Ankunft',
  flight_number: 'Flugnummer',
  airline: 'Fluggesellschaft',
  adults_number: 'Anzahl der Erwachsenen:',
  children_number: 'Anzahl der Kinder:',
  children_age: 'Alter der Kinder:',
  chosen_directions: 'Ausgewählte Richtungen:',
  destinations: 'Richtungen',
  chosen: 'Ausgewählt',
  destination: 'Richtung',
  destinations_first_plural: 'Richtungen',
  destinations_second_plural: 'Richtungen',
  option: 'Optionen',
  options_first_plural: 'Optionen',
  options_second_plural: 'Optionen',
  selected_airports: 'Ausgewählte Flughäfen:',
  airport: 'Flughafen',
  airports_first_plural: 'Flughäfen',
  airports_second_plural: 'Flughäfen',
  popular: 'Beliebt',
  germany: 'Deutschland',
  poland: 'Polen',
  other: 'Andere',
  airports: 'Flughäfen',
  no_airports: 'Keine Flughäfen',
  no_reviews: 'keine Noten',
  good: 'gut',
  'very-good': 'sehr gut',
  excellent: 'Ausgezeichnet',
  splendid: 'großartig ',
  magnificent: 'einzigartig',
  example_email: 'exemplarisch@email.pl',
  check: 'prüfen',
  checking: 'Überprüfung',
  offer_unavailable: 'Angebot nicht verfügbar',
  cheapest: 'Am billigsten!',
  no_element: 'Kein Gegenstand',
  departure_place: 'Abfahrt von',
  more_dates: 'Weitere Daten und Preise',
  no_available_offers: 'Keine Angebote verfügbar',
  no_operators: 'Keine Organisatoren',
  one_operator_selected: 'Veranstalter',
  operators_first_plural: 'Veranstalter',
  operators_second_plural: 'Veranstalter',
  person_shortcut: 'per.',
  to: 'Nieder',
  days_count: 'Anzahl der Tage:',
  choose_option: 'Wählen Sie die Option',
  all_inclusive: 'Alles inklusive',
  first_minute: 'Erste Minute',
  last_minute: 'Letzte Minute',
  invalid_content: 'Falscher Inhalt',
  see_all: 'Alles sehen',
  generate_offers_in_pdf: 'Angebote in pdf generieren',
  delete_all: 'alles entfernen',
  send_cupboard_to_email: 'Zwischenablage per E-Mail senden',
  delete_from_cupboard: 'Aus Zwischenablage entfernen',
  prices_and_dates_loading: 'Ladedaten und Preise ..',
  cupboard: 'Zwischenablage',
  no_offers_in_cupboard: 'Keine Angebote in der Zwischenablage',
  departure_from_day: 'Abfahrt von',
  arrival_to_day: 'Zurück zum Tag',
  choose_operator: 'Operator auswählen',
  loading_offer_options: 'Angebotsvarianten laden ..',
  type: 'Art',
  less_options: 'Weniger Optionen',
  more_options: 'Mehr Optionen',
  other_accommodation_options: 'Andere Optionen für Unterkunft und Verpflegung',
  together: 'zusammen',
  adult: 'Erwachsene',
  adults_selected_plural: 'Erwachsene',
  child: 'Kind',
  children_selected_plural: 'Kinder',
  hotel_placement_map: 'Karte des Hotelstandorts',
  domain_name: 'Holidayamigos.pl',
  sorry_offer_is_unavailable:
    'Das Angebot ist leider nicht mehr verfügbar. Bitte wählen Sie ein anderes Angebot.',
  sorry_error_occured:
    'Entschuldigung, ein Fehler ist aufgetreten. Bitte aktualisieren Sie die Seite oder wählen Sie ein anderes Angebot.',
  price_per_person: 'Preis pro Person',
  maximal_price_eur: 'Höchstpreis pro Person in Euro',
  hotel_standard: 'Hotelstandard',
  hotel_standard_from: 'Hotel Standard von',
  operator_name: 'Name des Veranstalters',
  operator_short: 'organisieren.',
  hide_prices: 'Daten und Preise ausblenden',
  do_you_know: 'Weißt du, dass...',
  one_more_moment: 'Noch ein Moment!',
  looking_for_best_offers: 'Wir suchen nur die besten Angebote für Sie!',
  found_offers: 'Angebote gefunden:',
  invalid_date_format: 'Ungültiges Datumsformat. Geben Sie DD.MM.YYYY',
  man: 'Mann',
  woman: 'Frau',
  transfer: 'Transfer',
  cash: 'Kasse',
  card: 'Karte',
  payment_on_airport: 'Zahlung am Flughafen',
  no_destinations: 'Keine Anweisungen',
  all_directions: 'Alle Richtungen',
  insurance: 'Versicherung',
  insurance_lowercase: 'Versicherung',
  insurance_price: 'Versicherungsprämie',
  hotel_only: 'Hotel',
  hotels: 'Hotels',
  only_hotels: 'Nur Hotels',
  holiday: 'Urlaub',
  trip: 'Ausflug',
  cruise: 'Kreuzfahrt',
  one_way_flight: 'Einwegflug',
  two_ways_flight: 'Rückflug',
  flight_tickets: 'Flugtickets',
  your_email_address: 'Deine Emailadresse',
  sign_up: 'Anmelden',
  rodo_info:
    'Gemäß dem Gesetz vom 18. Juli 2002 über die Bereitstellung elektronischer Dienste (Journal of Laws Nr. 144, Punkt 1204 in der jeweils gültigen Fassung) stimmen Sie durch das Abonnieren des Newsletters der elektronischen Übermittlung von Geschäftsinformationen durch Biuro Podróży Amigos BB Sp. Z oo zu. z o. o. in Jelenia Góra',
  signed_up:
    'Vielen Dank, dass Sie sich für unseren Newsletter angemeldet haben.',
  invalid_email_message:
    'Die E-Mail muss das folgende Format haben: exemplarisch@email.com oder j_kowal.nowak@exemplarisch.com.pl, ohne die deutschen Zeichen',
  export_to_pdf: 'In PDF exportieren',
  countries: 'Länder',
  regions: 'Regionen',
  categories: 'Kategorien',
  all: 'Alle',
  filter: 'Filter',
  filter_results: 'Filter Ergebnisse',
  base_data: 'Grundinformation',
  operators: 'Betreiber',
  original_description: 'Originalbeschreibung',
  description_translated: 'Google übersetzte Beschreibung',
  loading: 'Landung...',
  description: 'Beschreibung',
  descriptions: 'Beschreibungen ',
  excluding_owner: 'Ohne Amigos Beschreibungen',
  only_owner: 'Nur mit Amigos Beschreibung',
  show_offer_variants: 'Andere Daten und Preise anzeigen',
  hide_offer_variants: 'Kollapsdaten und Preise',
  show_dates_with_prices: 'Daten und Preise anzeigen',
  go_to_description: 'Siehe Beschreibung',
  terms_and_prices: 'Termine und Preise',
  check_offer: 'Verfügbarkeit prüfen',
  show_map: 'Karte anzeigen',
  facilities: 'Ausstattung',
  facilities_list: 'Liste der Annehmlichkeiten',
  show_gallery: 'Galerie anzeigen',
  show_flight_details: 'Flugdetails anzeigen',
  flights_details: 'Flugdaten',
  aditional_info: 'Zusätzliche Information',
  book_offer: 'Buchen Sie ein Angebot',
  hotel_reviews: 'Meinungen über das Hotel',
  show_hotel_reviews: 'Hotelbewertungen anzeigen',
  hotel_location: 'Hotellage',
  gallery: 'Galerie',
  equipment_and_facilities: 'Ausstattung und Ausstattung',
  contact_and_localization: 'Kontakt und Standort',
  contact_informations: 'Kontakt Informationen',
  inside_hotel: 'Im Hotel',
  inside_rooms: 'In den Zimmern',
  additional_attractions: 'Zusätzliche Attraktionen',
  localization: 'Ort',
  about_hotel: 'Über das Hotel',
  change_description_provider: 'Operatorbeschreibung ändern',
  description_is_translated:
    'Sie sehen jetzt die ursprüngliche Angebotsbeschreibung, die von Google Translate TM übersetzt wurde.',
  description_is_original:
    'Sie sehen jetzt die ursprüngliche Angebotsbeschreibung des Betreibers.',
  show_translation: 'ins Polnische übersetzen',
  show_original_text: 'Originaltext anzeigen',
  an_error_has_occurred:
    'Ein unerwarteter Beschreibungsfehler ist aufgetreten. Bitte aktualisieren Sie die Seite.',
  show_more: 'Zeig mehr',
  show_less: 'Zeige weniger',
  explanation_mark: 'Ausrufezeichen',
  providers_description_explanation:
    'Die ursprüngliche Beschreibung des Operators ist auf Deutsch, aber Sie können sie bequem mit einem automatischen Übersetzer übersetzen. Wenn Sie irgendwelche Zweifel haben, kontaktieren Sie uns bitte unter der Telefonnummer',
  providers_description_explanation_not_translatable:
    'Wenn Sie irgendwelche Zweifel haben, kontaktieren Sie uns bitte unter der Telefonnummer ',
  or_email: ', per E-Mail:',
  or_ask_about_offer: 'oder über die Schaltfläche Angebot anfordern.',
  call_us_phone: 'Anruf - Festnetztelefon',
  about_description_provider:
    'Die Beschreibung ist nur eine allgemeine Information über das Angebot. Eine detaillierte Beschreibung der Reise ist immer verfügbar, wenn Sie das Angebot einreichen.',
  why_from_germany: 'Warum aus Deutschland?',
  why_from_germany_link_title:
    'Lesen Sie, warum es sich lohnt, mit deutschen Betreibern zu reisen.',
  admin_special_offers_supplier: 'Anbieter',
  admin_special_offers_duration: 'Dauer des Aufenthalts',
  offer_type: 'Angebotsart',
  hotel_name: 'Name des Hotels oder Angebots',
  offer_search_empty: 'Keine Suchergebnisse',
  searching_in_progress: 'Suche ...',
  activity_changed: 'Die Infobox-Aktivität wurde geändert.',
  activity_change_error:
    'Beim Ändern der Aktivität ist ein Fehler aufgetreten. Bitte versuche es erneut.',
  sign_to_newsletter: 'Abonniere mich für den Newsletter',
  send_message: 'Eine Nachricht schicken',
  full_name: 'Vorname und Nachname',
  full_name_notification:
    'Der Text darf nicht kürzer als 3 Zeichen sein. Es darf keine Ziffern enthalten',
  email_address: 'E-Mail-Adresse',
  email_notification:
    'E-Mails müssen im folgenden Format vorliegen: email@exemplarisch.com, email_ger@exemplarisch.ger',
  phone_number: 'Telefonnummer',
  phone_number_notification: 'Das Telefon sollte 7 bis 15 Ziffern enthalten.',
  message_content: 'Nachrichteninhalt',
  message_content_notification:
    'Die Nachricht darf nicht kürzer als 3 und länger als 2000 Zeichen sein.',
  people_count: 'Anzahl der Personen',
  additional_comments: 'Zusätzliche Bemerkungen',
  preferred_airport: 'Bequemer Abflughafen',
  agreement_rules:
    'Ich habe die Bestimmungen und die Datenschutzerklärung gelesen und akzeptiere deren Bestimmungen',
  agreement_send:
    'Ich stimme zu, im Namen von mir und anderen Unternehmen kommerzielle Informationen an die angegebene E-Mail-Adresse zu senden. Die Einwilligung ist freiwillig und ich kann sie jederzeit widerrufen. Weitere Informationen zur Verarbeitung Ihrer personenbezogenen Daten und zur Ausübung Ihrer Rechte finden Sie in unserer Datenschutzerklärung.',
  must_accept_agreement: 'Zum Fortfahren ist die Zustimmung erforderlich',
  your_email: 'Email eingeben ... ',
  send_offer_to_mail:
    'Geben Sie Ihre E-Mail-Adresse ein und senden Sie ein Angebot',
  ask_us_about_offer: 'Bitte um ein Angebot',
  click_to_send: 'Zum Senden klicken',
  email_pending: 'Senden ...',
  offer_sent: 'Das Angebot wurde gesendet',
  offer_send_error: 'Fehler aufgetreten',
  offer_mail_invalid: 'Die angegebene E-Mail ist falsch',
  remove_all_favourites: 'Alle Elemente löschen',
  favourites_removed: 'Alle Gegenstände entfernt',
  favourites_no_data: 'Keine Artikel zu senden',
  send_favourites_to_mail: 'Zwischenablage per E-Mail senden',
  send_favourites_to_mail_pdf: 'Angebote im PDF-Format senden',
  favourites_sent: 'Zwischenablage wurde gesendet',
  remove_all_favourites_elements: 'Alle Elemente löschen?',
  yes: 'Ja',
  no: 'Nein',
  form_title: 'Fragen Sie uns nach einem Angebot',
  sub_title: 'Wir werden so schnell wie möglich antworten',
  message_is_sent: 'Nachricht wurde gesendet',
  message_is_sent_content:
    'Danke für deine Nachricht. Wir werden Ihre Fragen bald beantworten.',
  close: 'Schließen',
  ask_for_offer_name: 'Fragen Sie nach diesem Angebot',
  add_to_favourites: 'Zur Zwischenablage hinzufügen',
  added_to_favourites: 'Zur Zwischenablage hinzugefügt',
  favourites_error: 'Fehler beim Schreiben in die Zwischenablage',
  favourites_warning: 'Die Option ist in Ihrem Browser nicht verfügbar.',
  go_to_offer: 'Zum Angebot gehen',
  see_description: 'Siehe Beschreibung',
  reservation_form_title: 'Erstbestellung',
  reservation_form_title_agent: 'Als Agent buchen',
  about_reservation_cost: 'Das Ausfüllen des Formulars ist kostenlos.',
  about_contact_with_client:
    'Unser Berater wird sich mit Ihnen in Verbindung setzen, um die Reservierung zu bestätigen und die Zahlungsdetails zu vereinbaren.',
  agent_form_description:
    'Durch Ausfüllen des Formulars wird ein Buchungsposten erstellt, der Ihnen im Administrationsbereich zugewiesen wurde.',
  first_name: 'Name',
  client_first_name: 'Name des Kunden',
  last_name: 'Name',
  client_last_name: 'Nachname des Kunden',
  client_email_address: 'E-Mail-Adresse des Kunden',
  client_phone_number: 'Telefonnummer des Kunden',
  annotations: 'Bemerkungen',
  total_price: 'Gesamtpreis ',
  send_reservation: 'Buch',
  send_agent_reservation: 'Als Agent buchen',
  processing_personal_data:
    '* Ich stimme der Verarbeitung meiner persönlichen Daten durch Amigos B.B. zu. GmbH. in dem Formular für Zwecke im Zusammenhang mit der Zustellung der Bestellung enthalten.',
  rodo_information_1: 'Weitere Details im Dokument zu',
  rodo_information_2: 'Verarbeitung personenbezogener Daten.',
  pln: 'PLN',
  euro: '€',
  invalid_form_content:
    'Falsch ausgefülltes Buchungsformular. Bitte korrigieren Sie die Details und versuchen Sie es erneut.',
  accept_operator_condition: '*Ich stimme zu',
  accept_operator_condition_link_text: 'Betreiberbedingungen',
  sending: 'Senden',
  thank_you_for_reservation:
    'Vielen Dank für die Vorreservierung. Die Zusammenfassung wurde an die im Formular angegebene E-Mail gesendet. Unser Berater wird sich in Kürze mit Ihnen in Verbindung setzen.',
  thank_you_for_reservation_insurance:
    'Vielen Dank für die Vorreservierung. Die Zusammenfassung wurde an die im Formular angegebene E-Mail gesendet. Unser Berater wird sich in Kürze mit Ihnen in Verbindung setzen.',
  thank_you_for_reservation_agent:
    'Reservierung korrekt gespeichert. Gehen Sie zum Panel, um einen Vertrag für diese Reservierung zu erstellen.',
  newsletter_after_sign_up:
    'Innerhalb weniger Minuten erhalten Sie eine E-Mail mit einem Link zur Bestätigung des Abonnements. Klicken Sie darauf, wenn Sie Nachrichten von uns erhalten möchten.',
  checkbox_acceptance_error: 'Dieses Feld wird benötigt',
  show_reservation: 'Zur Buchung gehen ',
  show_reservations: 'Alle Reservierungen anzeigen',
  reservation_insurance: 'Reiseversicherung',
  registration_confirmation: 'Reservierungsbestätigung',
  initial_registration_confirmation: 'Bestätigung vor der Buchung',
  search_box_title: 'Verwirkliche deinen sonnigen Traum',
  search_box_emphasis: 'Suche nach der perfekten Reise',
  search_box_search_button: 'Nach einem Angebot suchen',
  filters_any: 'irgendein',
  filters_any_plural: 'irgendein',
  logged_in_msg: 'Sie sind derzeit angemeldet',
  offers: 'Bietet an',
  from: 'von',
  no_offers: 'Keine Angebote',
  system_error: 'Systemfehler',
  main_page: 'Zuhause',
  offers_list: 'Angebotsliste',
  no_offers_found:
    'Hmm, wir haben keine Angebote für die von Ihnen ausgewählten Parameter gefunden.',
  dont_be_worried:
    'Aber keine Sorge! Wir haben immer noch über 860.000 davon. <br>Ändern Sie Ihre Suchergebnisse oder sehen Sie sich beliebte Ziele an: <br> <a href="/wakacje/dominikana" title="Urlaub in der Dominikanischen Republik">Dominikanische Republik</a><a href="/wakacje/turcja" title="Urlaub in der Türkei"> Türkei </a> <a href="/wakacje/grecja" title="Urlaub in Griechenland"> Griechenland </a> <a href="/wakacje/hiszpania" title="Urlaub in Spanien"> Spanien </a> <a href="/wakacje/kuba" title="Urlaub in Kuba"> Kuba </a>',
  change_filters: 'Suchparameter ändern',
  offers_list_error: 'Entschuldigung, es ist ein Fehler aufgetreten :( ',
  days: 'Tage',
  refresh_page:
    'Bitte aktualisieren Sie die Seite oder versuchen Sie es später erneut.',
  contact_us: 'Kontaktiere uns',
  or: 'oder',
  flight_interchanges_info:
    'Zusätzliche Informationen zu Flugtransfers, die vom Betreiber bereitgestellt werden',
  flight_basic_info: 'Grundlegende Informationen zu Flügen',
  interchange: 'Veränderung',
  interchanges_included: 'Der Flug beinhaltet Änderungen',
  accommodation: 'Unterkunft',
  board: 'Catering',
  overall: 'Ganze',
  price_quality: 'Preis',
  service: 'Bedienung',
  total_reviews: 'Anzahl der Meinungen',
  attractions: 'Sehenswürdigkeiten',
  location: 'Position',
  reviews_provider: 'Urlaubsbewertung',
  review1: 'Meinung',
  review2: 'Meinungen',
  review3: 'Meinungen',
  read_more: 'Erweitern',
  read_less: 'Zusammenbruch',
  transfer_title: 'Transfer',
  with_transfer: 'Mit Transfer',
  without_transfer: 'Ohne Transfer',
  weather: 'Wetter',
  weather_graphs_title:
    'Durchschnittliche Wetterdaten nach Monaten aufgeschlüsselt',
  celsius_temperature: 'Temperatur in °C',
  day: 'Tag',
  night: 'Nacht',
  water_celsius_temperature: 'Wassertemperatur °C',
  sunny_hours_per_day: 'Anzahl der Sonnenstunden während des Tages',
  rainy_days_per_month: 'Anzahl der Regentage im Monat',
  widget_description:
    'Durchschnittliche Luft- und Wassertemperatur im ausgewählten Monat.',
  guarantee_sum: '90.000 €',
  guarantee_sum_description: 'garantierte Summe',
  started_from: '2002',
  started_from_description: 'Jahr auf dem Markt',
  operators_number: '37',
  operators_number_description_1: 'Deutsche',
  operators_number_description_2: 'Reiseveranstalter',
  coffee_title_1: 'es ist am besten, über Reisen zu sprechen',
  coffee_title_2: 'mit gutem Kaffee',
  coffee_description:
    'Besuchen Sie unser Reisebüro in Jelenia Góra und lassen Sie sich durch die Welt der besten Kreuzfahrtangebote führen. Unsere Mitarbeiter stehen Ihnen bei der Planung Ihres Traumurlaubs jederzeit mit Rat und Tat zur Seite.',
  hotel_name_filter: 'Hotelname',
  offer_expired_1: 'Das gesuchte Angebot ist leider abgelaufen. Prüfen',
  offer_expired_2: 'andere Daten und Preise',
  offer_expired_3: 'im',
  seo_offers_list: 'Angebotsliste',
  seo_region_information: 'Informationen über die Region',
  seo_practical_information: 'Praktische Information',
  seo_map: 'Karte',
  no_offers_contact_form_header:
    'Sie haben keine Zeit für eine Reise? <br> Unsere Spezialisten erledigen das für Sie!',
  no_more_offers_contact_form_header:
    'Dies sind alles verfügbare Angebote. Interessieren Sie sich für dieses Hotel? Kontaktieren Sie uns und wir werden das beste Datum und den besten Preis finden.',
  no_offers_contact_form_description:
    'Hinterlassen Sie Ihre Telefonnummer oder E-Mail-Adresse und wir werden Sie kontaktieren.',
  no_offers_contact_form_error:
    'Bitte geben Sie Ihre E-Mail-Adresse oder Telefonnummer ein.',
  no_offers_contact_form_button: 'Finde den besten Urlaub für mich',
  no_offers_contact_form_message_send_header: 'Danke ',
  no_offers_contact_form_message_send_description:
    'Unsere Spezialisten werden sich so schnell wie möglich mit Ihnen in Verbindung setzen. <br> Das Büro ist montags bis freitags von 9 bis 17 Uhr und samstags von 10 bis 14 Uhr geöffnet.',
  no_offers_contact_form_rodo_information:
    'Gemäß dem Gesetz vom 18. Juli 2002 über die Erbringung elektronischer Dienste (Journal of Laws Nr. 144, Punkt 1204 in der jeweils gültigen Fassung) stimmen Sie durch Übermittlung eines Kontaktantrags der Übermittlung von Geschäftsinformationen auf elektronischem Wege und dem Empfang eingehender Telefonanrufe zu Unterstützung bei der Auswahl eines Angebots gemäß Art. 172 des Telekommunikationsgesetzes von Biuro Podróży Amigos B.B. Sp z o.o in Jelenia Góra.',
  send: 'Senden',
  click_to_change: 'Klicken Sie, um zu ändern',
  press_enter_to_save:
    'Drücken Sie die Eingabetaste, um zu speichern, und klicken Sie auf Weiter, um die Änderungen zu verwerfen.',
  error_occurred_during_save: 'Schreibfehler bitte nochmal versuchen',
  action_save: 'Speichern',
  action_cancel: 'Stornieren',
  action_edit_note: 'Notiz bearbeiten',
  action_create_note: 'Notiz erstellen',
  why_holidays: 'WARUM URLAUB',
  with_german_operator: 'MIT EINEM DEUTSCHEN OPERATOR?',
  tours_with_german_operator_is_awesome:
    'Touren mit einem deutschen Veranstalter sind nur ein Plus!',
  our_clients_know_that_already:
    'Unsere Stammkunden wissen das bereits. Buchen Sie bei uns Touren aus Deutschland und genießen Sie Ihren Traumurlaub.',
  cheaper_holidays:
    'Urlaub ist <b> um bis zu 40% günstiger </b> <br> Zahlung in <b> Euro </b> oder <b> PLN </b>',
  cheaper_holidays_title: 'Billiger Urlaub',
  cheaper_holidays_alt: 'Sparschwein',
  protected_holidays: 'Ihre Abreise ist <b> geschützt </b>',
  protected_holidays_title: 'Reisen sind besser geschützt',
  more_requirements:
    'Die Betreiber müssen mehr Anforderungen erfüllen, um Touren organisieren zu können.',
  protected_holidays_alt: 'Geschützte Reise',
  better_quality:
    'Sie erhalten immer <b> ein Zimmer von besserer Qualität </b>',
  better_quality_title: 'Bessere Qualität Zimmer und Verpflegung',
  better_quality_alt: 'Fünf-Sterne-Hotel',
  compliance_with_description:
    'Das Hotel ist immer <b> im Einklang mit der Beschreibung </b> und <b> Preisstabilitätsgarantie </b>',
  compliance_with_description_title: 'Hotels wie beschrieben',
  compliance_with_description_alt: 'Einhaltung des Vertrages',
  more_destinations:
    '<b> ein breiteres Angebot </b> an Wegbeschreibungen und Daten sowie <b> moderne, komfortable Flugzeuge </b>',
  more_destinations_title: 'Weitere Daten und Anweisungen',
  more_destinations_alt: 'Reiserouten',
  why_with_german_operator_alt:
    'Prüfen Sie, warum es sich lohnt, mit einem deutschen Betreiber zu reisen.',
  why_holidays_with_german_operator:
    'Warum ein Urlaub bei einem deutschen Betreiber?',
  lower_prices: 'Urlaub ist um bis zu 40% günstiger',
  better_rooms:
    'Für den Preis bekommt man immer ein Zimmer von besserer Qualität.',
  better_safety:
    'Ihre Reise ist besser geschützt (die Betreiber müssen mehr Anforderungen erfüllen, um Reisen organisieren zu können).',
  always_consistent: 'Hotel immer wie beschrieben',
  more_destinations_and_dates: 'breiteres Angebot an Kursen und Terminen',
  office_phone_number: '+48 75 753 26 01',
  office_phone_number_no_spaces: '+48757532601',
  office_email: 'booking@wakacjeamigos.pl',
  save_contract: 'Speichern',
  generate_agreement: 'Vertrag erstellen',
  close_agreement: 'Vertrag beenden',
  reopen_agreement: 'Öffnen Sie einen Vertrag',
  agreement_notes: 'Anmerkungen',
  close_button_hint_text:
    'Markieren Sie den Vertrag als abgeschlossen und zur weiteren Bearbeitung bereit.',
  reopen_button_hint_text:
    'Ändern Sie den Vertragsstatus in "In Vorbereitung".',
  tab_agreement: 'Vertrag',
  tab_clients: 'Personen',
  tab_travel: 'Reise',
  tab_payments: 'Zahlungen',
  tab_send_documents: 'Senden',
  tab_history: 'Geschichte',
  agreement: 'Zustimmung',
  agent: 'Agent',
  representative: 'Makler',
  operator: 'Veranstalter',
  client: 'Vertragsabschluss',
  participants_data: 'Teilnehmerdaten',
  travel: 'Reise',
  transportation: 'Transport',
  accommodation_and_alimentation: 'Hotel und Catering',
  additional_information: 'Zusätzliche Information',
  summary: 'Zusammenfassung',
  payments: 'Zahlungen',
  kind_of_payment: 'Bezahlmöglichkeiten',
  send_documents_to_client: 'Dokumente als Anhänge an den Kunden senden',
  history_of_changes: 'Geschichte verändern',
  additional_documents: 'Anhängen ausgewählter Dateien an den Vertrag',
  office_documents: 'Amigos Dokumente',
  operators_documents: 'Betreiberdokumente',
  contract_additional_files: 'Zur Vereinbarung hinzugefügte Dateien',
  payments_accounts_numbers: 'Kontonummern',
  history_of_documents_send: 'Geschichte der gesendeten Dokumente',
  contract_agreement_date: 'Datum des Vertragsschlusses',
  contract_agreement_place: 'Ort des Vertragsschlusses',
  contract_agreement_type: 'Reservierungsart',
  contract_agreement_status: 'Vertragsstatus',
  contract_etax_number: 'Etax Nummer',
  contract_office_name: 'Büroname',
  contract_office_address: 'Büro adresse',
  contract_office_city: 'Stadt',
  contract_agent_name: 'Name',
  contract_agent_surname: 'Name',
  contract_agent_email: 'Email',
  contract_agent_phone: 'Telefon',
  contract_representative_name: 'Name',
  contract_representative_address: 'Adresse',
  contract_representative_person: 'Vertreter',
  contract_representative_krs: 'KRS',
  contract_representative_nip: 'NIP',
  contract_operator_name: 'Name des Bedieners',
  contract_operator_code: 'Anwender Code',
  contract_operator_reservation_number: 'Reservierungsnummer',
  clients_gender: 'Sex',
  clients_surname: 'Name',
  clients_name: 'Name',
  clients_pesel: 'Pesel',
  clients_phone: 'Telefon',
  clients_country: 'Zustand',
  clients_address_code: 'Postleitzahl',
  clients_city: 'Stadt',
  clients_address: 'Adresse',
  clients_email: 'Email',
  clients_date_of_birth: 'Geburtsdatum',
  clients_currency: 'Währung',
  clients_reservation_price: 'Reservierungspreis',
  clients_cancelation_insurance_price: 'Versicherer Stornokosten: Betrag',
  clients_cancelation_insurance_percent: 'Versicherer Stornokosten:%',
  clients_interuption_insurance_price:
    'Versicherer Reiseunterbrechungenkosten: Betrag',
  clients_interuption_insurance_percent:
    'Versicherer Reiseunterbrechungenkosten:%',
  clients_compulsory_insurance: 'Pflichtversicherung',
  clients_tfg: 'Touristengarantiefonds',
  clients_additional_insurance: 'Zusätzliche Versicherung',
  clients_add_last_participants_button:
    'Daten von Teilnehmern aus dem vorherigen Vertrag übertragen',
  clients_insurance: 'Versicherung',
  travel_destination: 'Ziel',
  travel_departure: 'Abfahrt',
  travel_arrival: 'Rückkehr',
  travel_time_period: 'Anzahl der Tage',
  travel_insurance_from: 'Versicherungsdauer ab:',
  travel_insurance_to: 'Versicherungsdauer bis:',
  travel_reservation_type: 'Reservierungsart',
  travel_departure_arrival_airport: 'Abflug: Flughafen der Ankunft',
  travel_date: 'Datum',
  travel_hour: 'Stunde',
  travel_arrival_airport: 'Flughafen der Ankunft',
  travel_departure_airport: 'Abflughafen',
  travel_departure_place_verb: 'Abfahrt',
  travel_arrival_place_verb: 'Rückkehr',
  travel_contact_point: 'Treffpunkt',
  accommodation_city: 'Stadt',
  accommodation_hotel_name: 'Hotelname',
  accommodation_standard: 'Standard',
  accommodation_type: 'Unterkunft',
  accommodation_alimentation_type: 'Art von Essen',
  additional_information_templates: 'Zusätzliche Informationsvorlagen',
  payments_receiver: 'Zahlungsempfänger',
  payments_method: 'Zahlungsmethode',
  disabled_unsaved_button_title:
    'Speichern Sie die Änderungen, um fortzufahren.',
  disabled_external_contract_not_attached:
    'Der Vertrag kann nicht ohne den beigefügten deutschen Vertrag geschlossen werden.',
  disabled_agent_not_allowed_to_reopen_contract:
    'Sie können keinen geschlossenen Vertrag eröffnen. Wenden Sie sich an das Büro von amigos.',
  disabled_contract_not_ready_to_be_saved:
    'Füllen Sie alle fehlenden Daten aus',
  payments_summary_cancellation_insurance: 'Versicherer auf Rücktrittskosten',
  payments_summary_interuption_insurance:
    'Versicherer auf Reiseunterbrechungenkosten',
  payments_summary_tfg: 'Der Tourist. Garantiefonds:',
  payments_summary_compulsory_insurance: 'Pflichtversicherung:',
  payments_summary_additional_insurance: 'Zusätzliche Versicherung:',
  payments_summary_reservations_sum:
    'Gesamtsumme der Reservierungen der Teilnehmer',
  payments_summary_insurances_sum: 'Gesamtsumme der Versicherten:',
  payments_summary_type: 'Wählen Sie Ihr Zahlungsdatum',
  payments_insurance_set: 'Versicherung geregelt',
  payment_pln_sum: 'Betrag in PLN',
  payment_eur_sum: 'Betrag in EUR',
  payments_all_date: 'Datum',
  payments_advance_day: 'Vorauszahlung am:',
  payments_advance_rest_day: 'Zuschlag bis:',
  payments_advance: 'Vorauszahlung:',
  payments_advance_percent: 'Voraus [%]',
  payments_advance_rest: 'Ergänzung',
  payments_all_sum: 'Ganze',
  documents_client_email: 'Kunden-E-Mail (Adressat)',
  documents_client_email_text_message: 'Nachrichteninhalt',
  contract_cannot_be_blank: 'Das Feld darf nicht leer sein',
  constract_not_valid_reservation_number:
    'Geben Sie eine gültige Buchungsnummer ein',
  add_client_to_participants: 'Zu den Teilnehmern hinzufügen',
  add_participant: 'Teilnehmer hinzufügen',
  dates_cannot_be_blank: 'Geben Sie die Abfahrts- und Rückreisedaten ein',
  dates_order_not_valid: 'Ungültige Datumsreihenfolge',
  pesel_number_should_have_valid_length: 'Ungültige Pesel-Nummer',
  email_should_be_valid: 'Falsche E-Mail Adresse',
  percent_invalid_format: 'Falscher Wert',
  price_invalid_format: 'Ungültige Menge',
  attachment_cannot_be_larger_than:
    'Die Größe der Anhänge darf 25 MB nicht überschreiten! Der Client erhält die Nachricht nicht.',
  history_person_modified: 'Person',
  history_type_change: 'Teilen',
  history_change_date: 'Datum',
  created: 'Vertragsabschluss',
  modified: 'Änderung',
  exported_to_pdf: 'Export nach pdf',
  document_uploaded: 'Datei hinzufügen',
  document_deleted: 'Datei löschen',
  email_sent: 'E-Mail gesendet',
  insurance_email_sent: 'Versicherungsauszug gesendet',
  failed_to_send_insurance_email: 'Versandfehler Versicherungserklärung',
  failed_to_send_email: 'E-Mail-Versandfehler',
  contract_finalized: 'Status geändert in "Geschlossen"',
  contract_set_to_pending: 'Status geändert in "In Vorbereitung"',
  history_field_name: 'Feldname',
  history_field_before_change: 'Vor dem Wechsel',
  history_field_after_change: 'Nach der veränderung',
  send_history_filename: 'Dateiname',
  history_insurance_name: 'Name der Versicherung',
  history_insurance_sent: 'Wurde es gesendet (V/X)?',
  history_cancellation_insurance: 'Reiserücktrittsversicherung',
  history_interuption_insurance: 'Pannenversicherung',
  history_compulsory_insurance: 'Obligatorische Versicherung',
  history_additional_insurance: 'Zusatzversicherung',
  history_cancellation_insurance_short: 'KR',
  history_interuption_insurance_short: 'KP',
  history_compulsory_insurance_short: 'Obligatorische',
  history_additional_insurance_short: 'Zusätzliche',
  history_insurance_date: 'Datum des Versands',

  documents_add_additional_files:
    'Fügen Sie dem Vertrag zusätzliche Dateien hinzu',
  documents_add_external_contract_file: 'Deutsche Vertragsdatei hinzufügen',
  documents_send_contract: 'Dokumente senden',
  documents_abort_sending: 'Stornieren',
  drag_and_drop_max_size_hint: 'Maximale Größe aller Anhänge',
  drag_and_drop_disabled_text:
    'Speichern Sie die Vereinbarung zum Hinzufügen von Dateien.',
  documents_message_send_password: 'Geschickt! Vertragspasswort:',
  documents_email_message_not_send: 'Fehler, Nachricht wurde nicht gesendet',
  documents_remember_to_save_contract:
    'Denken Sie daran, den Vertrag zu speichern, bevor Sie ihn an den Kunden senden!',
  remove_file_title: 'Datei löschen',
  file_encrypted: 'Passwortverschlüsselte Datei',
  documents_drag_and_drop_additional_hint:
    'Die Dateien werden an die verschlüsselte Vereinbarung angehängt.',
  documents_summary_email: 'E-Mail-Adresse',
  documents_summary_content: 'Nachrichteninhalt',
  documents_summary_documents: 'Liste der Dokumente',
  documents_summary_total_documents_weight: 'Summe der Anhänge',
  documents_summary_contract: 'Zustimmung',
  settlements_filter: 'Show',
  settlements_filter_export_option: 'Art des Exports',
  settlements_filter_date_to: 'Datum {date_attribute} bis',
  settlements_filter_date_from: 'Datum {date_attribute} von',
  date_attribute_departure_date: 'Abfahrt',
  date_attribute_return_date: 'Rückkehr',
  date_attribute_contract_date: 'Verträge',
  date_attribute_insurances_sent_date: 'Senden versichert',
  settlements_filter_title:
    'Drücken Sie die Taste, um die Verträge für den Export anzuzeigen.',
  settlements_filter_status_all: 'Alle',
  settlements_filter_agent_label: 'Agentur',
  settlements_filter_agent_all: 'Agenturen + Amigos',
  settlements_export: 'Export nach .xlsx',
  settlements_export_title:
    'Drücken Sie die Taste, um die XLSX-Datei herunterzuladen.',
  offers_collection_index_header: 'Nach Angeboten suchen',
  choose_a_region: 'Region auswählen',
  choose_airports: 'Flughäfen auswählen',
  choose_operators: 'Wählen Sie Operatoren',
  adults_count: 'Erwachsene',
  children_count: 'Kinder',
  min_standard: 'Standard von',
  missing: 'Mangel',
  trip_length: 'Besuchszeit',
  trip_length_from: 'Bleib weg von',
  trip_length_days: '(Tage)',
  trip_length_to: 'Bleib bei',
  max_price_eur: 'Maximaler Preis',
  euro_per_person: '(EUR / Person)',
  chosen_regions: 'Ausgewählte Regionen',
  chosen_airports: 'Ausgewählte Flughäfen',
  chosen_operators: 'Ausgewählte Betreiber',
  hotels_per_region: 'Anzahl der Hotels pro Region',
  parser_list: 'Quelle',
  flex_types: 'Flex Tariffe',
  located_list: 'Lage',
  search: 'Suche',
  not_chosen: 'Nicht ausgewählt',
  columns_in_table: 'Spalten in der Tabelle',
  offers_collection_region: 'Region',
  offers_collection_hotel_name: 'Hotel',
  offers_collection_flight_departure: 'Abfahrt',
  offers_collection_city: 'Stadt',
  offers_collection_flight_arrival: 'Ankunft',
  offers_collection_stars: '*',
  offers_collection_ratings: 'Bewertung',
  offers_collection_operator: 'Organ.',
  offers_collection_price: 'Preis',
  offers_collection_departure_date: 'Abfahrt',
  offers_collection_arrival_date: 'Rückkehr',
  offers_collection_day_count: 'Tage',
  offers_collection_accommodation: 'Unterkunft',
  offers_collection_board: 'Catering',
  offers_collection_train_to_airport: 'Zug zum Flughafen',
  search_results: 'Suchergebnisse',
  saved_searches: 'Gespeicherte Suche',
  selected_offers: 'Ausgewählte Angebote',
  add_offers_to_selected: 'Markierte zu ausgewählten Angeboten hinzufügen',
  send_offers_collection: 'Angebot senden',
  subject: 'Titel',
  body: 'Inhalt',
  all_regions: 'Alle Regionen',
  offers_per_hotel_count: 'Anzahl der Angebote für das Hotel',
  check_prices: 'Preise prüfen',
  preview_attachment: 'Anhangsvorschau',
  send_collection_with_email:
    'Erstellen Sie aus den ausgewählten ein Angebot und senden Sie es per E-Mail.',
  offers_collection_default_email_subject: 'Amigos Urlaubsangebot',
  add_emails: 'eine weitere Adresse hinzufügen',
  offers_collection_preview_filename: 'Vorschau anbieten ',
  error_during_offers_collection_preview:
    'Beim Herunterladen der Angebotsvorschau ist ein Fehler aufgetreten.',
  error_during_offers_collection_send:
    'Beim Senden des Angebots ist ein Fehler aufgetreten.',
  error_during_getting_regions_prices:
    'Beim Abrufen der Regionalpreise ist ein Fehler aufgetreten.',
  error_during_saving_filters:
    'Es gab einen Fehler beim Speichern von Filtern.',
  NOT_AVAILABLE: 'Nicht verfügbar',
  AVAILABLE: 'Verfügbar',
  ON_REQUEST: 'Auf Anfrage verfügbar',
  chosen_boards: 'Ausgewählte Mahlzeiten',
  chosen_accommodations: 'Ausgewählte Unterkunft',
  chosen_facilities: 'Ausgewählte Annehmlichkeiten',
  create_offers_collection_pdf:
    'Erstellen Sie ein Angebot aus dem ausgewählten Angebot und laden Sie das PDF herunter.',
  request_name: 'Suchname',
  unnamed: '[kein Name]',
  save_request: 'Sichere Suche',
  reviews: 'Meinungen',
  offers_collection_email_sent: 'Das Angebot wurde erfolgreich gesendet',
  pick_from_list: 'Aus Liste auswählen',
  offers_collection_find_region: 'Region finden',
  offers_collection_load_more_offers: 'Weitere Angebote anzeigen',
  choose_from_saved: 'Wählen Sie aus gespeichert',
  confirm_filters_request_delete: 'Möchten Sie diese Suche wirklich löschen?',
  search_blog: 'Durchsuche den Blog',
  look_for: 'Suche',
  departure_from: 'Abfahrt von ...',
  trip_direction: 'Fahrtrichtung',
  adults_count_filter: 'Anzahl der Erwachsenen',
  children_count_filter: 'Anzahl der Kinder',
  similar_entries_label: 'Verwandte Elemente (unten auf der Seite sichtbar)',
  price_from: 'von',
  currency_pln: 'PLN',
  per_person: '/per.',
  total: 'gesamt',
  see_more_offers: 'Weitere Angebote anzeigen',
  search_for_trip: 'Suche nach einer Reise',
  'hotel-name': 'Hotelname',
  'hotel-location': 'Ort',
  'hotel-country-region-city': 'Land, Region, Stadt',
  'hotel-region-city': 'Region, Stadt',
  'hotel-city': 'Stadt',
  'hotel-rating': 'Standard',
  'hotel-opinions': 'Bewertung',
  no_hotels_found:
    'Wir haben keine Hotels mit den von Ihnen ausgewählten Parametern gefunden.',
  hotel_name_search_message: 'Suchergebnisse für',
  'Not redirecting: empty value of':
    'Weiterleitung nicht durchgeführt: leerer Wert',
  search_for_hotel: 'Suche nach einem Hotel',
  hotel_list_title: 'Liste der Hotels',
  hotel_list_subtitle:
    'Wählen Sie ein Land, eine Region oder suchen Sie nach einem Hotel',
  go_back_to_hotel_list: 'Gehen Sie zurück zur Liste der Regionen',
  recommended_regions_header: 'Empfohlene Anweisungen',
  recommended_regions_subheader: 'Wählen Sie die Tour, die zu Ihnen passt',
  recommended_regions_exotic_tours: 'Exotische Expeditionen',
  recommended_regions_nearby_destinations: 'Anweisungen schließen',
  reservation_type_b: 'B - ständige Reservierung',
  reservation_type_op: 'OP - Option',
  reservation_type_rq: 'RQ - auf Anfrage',
  payment_option_all: 'Alles am Tag der Vertragsunterzeichnung',
  payment_option_advance:
    'Vorauszahlung am Tag der Vertragsunterzeichnung + Nachzahlung',
  contract_in_attachment:
    'Im Anhang senden wir den polnischen Vertrag, die deutsche Buchung, die allgemeinen Teilnahmebedingungen des Veranstalters, die allgemeinen Versicherungsbedingungen sowie eine Beschreibung des Hotels und der Dienstleistungen. Das Passwort zum Öffnen der Anhänge ist das Geburtsjahr der Person, die den Vertrag abschließt. \nBitte überprüfen Sie die Richtigkeit der eingegebenen persönlichen Daten und Reiseparameter, unterschreiben Sie die Dokumente und senden Sie sie per E-Mail zurück. Zahlungsinformationen und Kontonummern finden Sie in der polnischen Vereinbarung. \nWir stehen zu Ihrer Verfügung',
  additional_information_first_short: 'Flugstunden sind nicht bindend',
  additional_information_first:
    'Flugstunden sind nicht bindend und können sich den ganzen Tag ändern.',
  additional_information_second_short: 'ERFORDERLICHE PASSGÜLTIGKEIT',
  additional_information_second:
    'DIE ERFORDERLICHE GÜLTIGKEIT DES PASSES IST 6 MONATE AB DEM RÜCKGABEDATUM.',
  additional_information_third_short:
    'IN-SITE BEZAHLTE TOURISTISCHE STEUER ...',
  additional_information_third:
    'BEZAHLTE TOURISTISCHE STEUER ABHÄNGIG VON HOTEL STANDARD',
  additional_information_fourth_short:
    'ZUSÄTZLICH BEZAHLTES TOURISTISCHES VISA ZUM PREIS',
  additional_information_fourth:
    'ZUSÄTZLICH BEZAHLTES TOURISTISCHES VISA ZUM PREIS',
  additional_information_fifth_short:
    'SONDERANGEBOT BUCHUNG, OHNE ÄNDERUNG ...',
  additional_information_fifth:
    'BUCHUNG AUS EINEM SONDERANGEBOT OHNE MÖGLICHE ÄNDERUNGEN - BESONDERE STORNIERUNGSBEDINGUNGEN DER BUCHUNG BIS ZU 100% DER REISE',
  additional_information_sixth_short:
    'BUCHEN MIT LINIENFLUG / NIEDRIGER LINIENFLUG OHNE ÄNDERUNG ...',
  additional_information_sixth:
    'BUCHEN MIT LINIENFLUG / GÜNSTIGE LINIE OHNE ÄNDERUNGEN - STORNIERUNGSKOSTEN BIS ZU 100% DER REISE',
  additional_information_seventh_short:
    'DAS ANGEBOT ENTHÄLT DIE ÜBERTRAGUNG VOR ORT',
  additional_information_seventh: 'DAS ANGEBOT ENTHÄLT DIE ÜBERTRAGUNG VOR ORT',
  additional_information_eighth_short:
    'DAS ANGEBOT ENTHÄLT KEINE ÜBERTRAGUNG VOR ORT',
  additional_information_eighth:
    'DAS ANGEBOT ENTHÄLT KEINE ÜBERTRAGUNG VOR ORT',
  additional_information_ninth_short:
    'ANNAHME DER AKTUELLEN WARNHINWEISE DES MFA',
  additional_information_ninth:
    'DER KUNDE HAT DIE AKTUELLEN WARNHINWEISE DES MFA BETROFFEN UND AKZEPTIERT',
  additional_information_tenth_short:
    'WIRTSCHAFTSRAUM / SPAR / BESTPREIS KÖNNEN KLEINER SEIN ...',
  additional_information_tenth:
    'DER WIRTSCHAFTS- / SPAR- / BESTPREIS-RAUM KANN KLEINER UND / ODER SCHLECHTER SEIN',
  additional_information_eleventh_short:
    'VISEN ZUR TÜRKEI MÜSSEN ZUR VERFÜGUNG GESTELLT WERDEN ...',
  additional_information_eleventh:
    'VISAS FÜR DIE TÜRKEI MÜSSEN VOR DER ABFAHRTSKOSTEN GEGEBEN WERDEN (EINZELN ODER DURCH DAS BÜRO)',
  additional_information_twelfth_short:
    'EMPFOHLENE IMPFUNGEN - BITTE KONTAKTIEREN ...',
  additional_information_twelfth:
    'EMPFOHLENE IMPFUNGEN - BITTE KONTAKTIEREN SIE DIE NÄCHSTE SANEPID-STATION.',
  additional_information_thirteenth_short:
    'ABFAHRT NUR MIT EINEM GÜLTIGEN PASS',
  additional_information_thirteenth: 'ABFAHRT NUR MIT EINEM GÜLTIGEN PASS',
  additional_information_fourteenth_short: 'KINDER SCHLAFEN MIT ELTERN',
  additional_information_fourteenth: 'KINDER SCHLAFEN MIT ELTERN',
  additional_information_fifteenth_short: 'DIE ANZAHL DER PLÄTZE IST BEGRENZT',
  additional_information_fifteenth: 'DIE ANZAHL DER PLÄTZE IST BEGRENZT',
  additional_information_sixteenth_short: 'DIE ANZAHL DER PLÄTZE IST BEGRENZT',
  additional_information_sixteenth: 'DIE ANZAHL DER PLÄTZE IST BEGRENZT',
  additional_information_seventeenth_short:
    'ES IST EIN VISUM ERFORDERLICH - INDIVIDUELL ODER ...',
  additional_information_seventeenth:
    'ES IST EIN VISUM ERFORDERLICH - INDIVIDUELL ODER DURCH EIN REISEBÜRO. DIE VISUMSKOSTEN TRÄGT DER KUNDE.',
  additional_information_eighteenth_short:
    'ALL-INCLUSIVE VERPFLEGUNG GEMÄß MITTEILUNG ...',
  additional_information_eightteenth:
    'ALL-INCLUSIVE VERPFLEGUNG GEMÄß MITTEILUNG - IM PREIS INBEGRIFFEN.',
  additional_information_nineteenth_short: 'KREUZFAHRTROUTE IM ANHANG',
  additional_information_nineteenth: 'KREUZFAHRTROUTE IM ANHANG.',

  pesel_for_old_contract:
    'Der Vertrag wurde auf Basis der PESEL-Nummer erstellt',

  invoice: 'Rechnung',
  'credit card': 'Kreditkarte',
  sepa: 'SEPA',
  'direct debit': 'Lastschrift',
  paypal: 'Paypal',

  add_page: 'Seite hinzufügen',
  please_correct: 'Bitte beheben Sie die folgenden Probleme:',
  required: 'Erforderlich',
  url_address: 'URL-Adresse',
  thumbnail: 'Miniaturansicht',
  add: 'Hinzufügen',
  nr: 'Nr.',
  is_active: 'Aktiv?',
  actions: 'Aktionen',
  page_name: 'Seitenname',
  category_link: 'Link zur Angebotsseite',

  add_url_error: 'Geben Sie die URL des Eintrags ein',
  wrong_url_error: 'Ungültige Eintrags-URL',
  add_thumbnail_error: 'Hängen Sie dem Angebot ein Vorschaubild an',

  confirm_tv_offers_category_delete:
    'Möchten Sie diese Jobseite wirklich löschen?',
  confirm_tv_offer_delete: 'Möchten Sie dieses Angebot wirklich löschen?',

  scan_qr: 'Scannen Sie den QR-Code und überprüfen Sie dieses Angebot:',
  departure_colon: 'Abfahrt:',
  pln_per_person: 'PLN/Person',
  site_name: 'wakacjeamigos.pl',

  get_inspired: 'Wohin in den Urlaub fahren? - Lassen Sie sich inspirieren',
  choose_category:
    'Suchen Sie aus ausgewählten Kategorien nach dem perfekten Angebot',
  check_categorie: 'Schauen Sie sich die Angebote an',
  look_at: 'Blick:',

  check_special_offers: 'Lassen Sie sich das nicht entgehen – tolle Angebote!',
  chosen_by_our_experts: 'Von unseren Spezialisten empfohlen',
  from_germany: 'Von Deutschland',
  exotic_places: 'Egzotyka',
  with_children: 'Exotik',
  without_passport: 'Kein Reisepass',
  more_offers: 'weitere Angebote'
};



// WEBPACK FOOTER //
// ./common/locale/de.js